import Vue from 'vue'
import Navigation from './Navigation'

Vue.component('navbar', Navigation)



// WEBPACK FOOTER //
// ./src/components/index.js